import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/catalogos/productos/fotos", "documento": "catalogs", "acceso": "sesion", "filas": ["170"], "cita": "Areas/Catalogs/Controllers/ProductPhotosController.cs"} satisfies RutaProd;
